import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const Stepper = ({ active, steps }) => {
  const { t } = useTranslation();

  const stepper = steps.map((step, key) => {
    let className = '';
    if ((active + 1) === key + 1) className = 'active';
    else if ((active + 1) > key + 1) className = 'done';

    return (<li key={`${step}`} className={className}><span>{t(`reports.stepper.${step}.name`)}</span></li>);
  });

  return (
    <ul className={`progressbar steps-${steps.length}`}>
      {stepper}
    </ul>
  );
};

export default Stepper;

Stepper.propTypes = {
  active: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf.isRequired,
};
